export function encodeBaseN(bytes: Uint8Array, baseChars: string): string {
  const base = baseChars.length;
  if (bytes.length === 0) return '';

  let digits = [0];
  for (let i = 0; i < bytes.length; i++) {
    let carry = bytes[i];
    for (let j = 0; j < digits.length; j++) {
      const val = digits[j] * 256 + carry;
      digits[j] = val % base;
      carry = Math.floor(val / base);
    }
    while (carry > 0) {
      digits.push(carry % base);
      carry = Math.floor(carry / base);
    }
  }

  return digits.reverse().map(d => baseChars[d]).join('');
}

export function decodeBaseN(str: string, baseChars: string): Uint8Array {
  const base = baseChars.length;
  if (!str) return new Uint8Array([]);

  const charMap: Record<string, number> = {};
  for (let i = 0; i < baseChars.length; i++) {
    charMap[baseChars[i]] = i;
  }

  let bytes = [0];
  for (let i = 0; i < str.length; i++) {
    const val = charMap[str[i]];
    if (val === undefined) throw new Error(`Invalid character '${str[i]}'`);

    let carry = val;
    for (let j = 0; j < bytes.length; j++) {
      const x = bytes[j] * base + carry;
      bytes[j] = x & 0xff;
      carry = x >> 8;
    }
    while (carry > 0) {
      bytes.push(carry & 0xff);
      carry >>= 8;
    }
  }

  return Uint8Array.from(bytes.reverse());
}
